import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './views/store/store'
import http from './utils/http'
import httplogin from './utils/httplogin'
import { installFoodLicenseRecordPatch } from './utils/foodLicenseRecord'
import VCharts from 'v-charts'



import './plugins/element.js'
Vue.use(VCharts)
Vue.config.productionTip = false
Vue.prototype.$http = http
Vue.prototype.$httplogin = httplogin
installFoodLicenseRecordPatch()

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
